import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Satellites from "./Pages/Satellites/Satellites";
import Cybersecurity from "./Pages/Cybersecurity/Cybersecurity";
import Networks from "./Pages/Networks/Networks";
import Surveillance from "./Pages/Surveillance/Surveillance";
import PowerSolutions from "./Pages/PowerSolutions/PowerSolutions";
import Professionalservices from "./Pages/Professional services/Professional services";
import ContactUs from "./Pages/ContactUs/ContactUs";
import Career from "./Pages/Career/Career";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import MobMenu from "./Components/MobMenu/MobMenu";
import PreReleaseWraper from "./Modules/PressReleases/Pages/PressReleaseWraper";
import LeasderShipWraper from "./Modules/LeaderShip/Pages/LeasderShipWraper";
import ImranFarooq from "./Modules/LeaderShip/Pages/ImranFarooqCTO";
import AliCEO from "./Modules/LeaderShip/Pages/AliCEO";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import CareerOpenings from "./Pages/CareerOpenings/CareerOpenings";
import AamirHeadBu from "./Modules/LeaderShip/Pages/AamirHeadBu";
import TerraMonitor from "./Pages/IotPages/TerraMonitor";
import Umeter from "./Pages/IotPages/Umeter";
import Dynalock from "./Pages/IotPages/Dynalock";
import DynaTrace from "./Pages/IotPages/DynaTrace";
import CitySense from "./Pages/IotPages/CitySense";
import Dynafleet from "./Pages/IotPages/Dynafleet";
import EcoClean from "./Pages/IotPages/EcoClean";
import InteliPark from "./Pages/IotPages/InteliPark";
import SmartSentry from "./Pages/IotPages/SmartSentry";
import NewLanding from "./Pages/Landing/NewLanding";
import IotLanding from "./Pages/IotPages/IotLanding";
import SatelliteCommunications from "./Pages/SatelliteComPages/SatelliteCommunications";
import Flyaway from "./Pages/SatelliteComPages/Flyaway";
import SatcomAntenna from "./Pages/SatelliteComPages/SatcomAntenna ";
import SatcomFlyaway from "./Pages/SatelliteComPages/SatcomFlyaway";
// import ScreenSize from "./Components/ScreenSize/ScreenSize";
import { GlobalProvider } from "./Components/GlobalContext/GlobalContext";
import Partners from "./Pages/Partners/Partners";
import UzairHeadOfProducts_Iot from "./Modules/LeaderShip/Pages/UzairHeadOfProducts_Iot";
import PressReleasePage from "./Modules/PressReleases/Pages/PressReleasePage";
import PageNotFound from "./Components/PageNotFound/PageNotFound";

function App() {
  return (
    <div className="App">
      <GlobalProvider>
        <BrowserRouter>
          {/*  <ScreenSize /> */}
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<NewLanding />} />
            <Route path="/whoweare" element={<AboutUs />} />
            <Route path="/satellites" element={<Satellites />} />
            <Route path="/cybersecurity" element={<Cybersecurity />} />
            <Route path="/networks" element={<Networks />} />
            <Route path="/surveillance" element={<Surveillance />} />
            <Route path="/powersolutions" element={<PowerSolutions />} />
            <Route
              path="/professionalservices"
              element={<Professionalservices />}
            />

            {/* Our News Routes */}
            <Route path="/our_news" element={<PreReleaseWraper />} />

            {/* PRESS RELEASES DYNAMIC ROUTES  */}
            <Route path="/our_news/:id" element={<PressReleasePage />} />
            <Route path="/:id" element={<PressReleasePage />} />

            {/* LeaderShip routes */}
            <Route path="/leadership" element={<LeasderShipWraper />} />
            <Route path="/founder&ceo" element={<AliCEO />} />
            {/* <Route path="/chief_technology_officer" element={<ImranFarooq />} /> */}
            <Route
              path="/head _of_products_iot"
              element={<UzairHeadOfProducts_Iot />}
            />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/available_positions" element={<CareerOpenings />} />
            <Route path="/mobmenu" element={<MobMenu />} />

            {/* IOT PAGES ROUTES  */}
            <Route path="/iot" element={<IotLanding />} />
            <Route path="/teramonitor" element={<TerraMonitor />} />
            <Route path="/umeter" element={<Umeter />} />
            <Route path="/dynalock" element={<Dynalock />} />
            <Route path="/dynatrace" element={<DynaTrace />} />
            <Route path="/citysense" element={<CitySense />} />
            <Route path="/dynafleet" element={<Dynafleet />} />
            <Route path="/ecoclean" element={<EcoClean />} />
            <Route path="/intelipark" element={<InteliPark />} />
            <Route path="/smartsentry" element={<SmartSentry />} />

            {/* SATELLITE COMMUNICATIONS PAGES ROUTES  */}
            <Route
              path="/satellite_communications"
              element={<SatelliteCommunications />}
            />
            <Route path="/0.9m_flyaway_ku_band" element={<Flyaway />} />
            <Route path="/1.2m_fixed_ku_band" element={<SatcomAntenna />} />
            <Route path="/1.2m_flyaway_ku_band" element={<SatcomFlyaway />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </GlobalProvider>
    </div>
  );
}

export default App;
